import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetType } from '@app/_models/enums/assetType';
import { AssetHistoryActionName, AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { environment } from '@environments/environment';
import { Media } from '@app/_models/_DTOs/media';
import { AssetService } from '@app/_services';
import { DocumentService } from '@app/_services/document.service';
import { NzMessageService } from 'ng-zorro-antd';
import { ResizeService } from '@app/_services/resize.service';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { Employee } from '@app/_models/_DTOs/employee';
import { Subject } from 'rxjs';
import { ITuple } from '@app/_models/tuple';
import { LocationService } from '@app/_services/location.service';
import { EmployeeService } from '@app/_services/employee.service';
import { Location } from '@app/_models/_DTOs/location';

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.css']
})
export class AdminPageComponent implements OnInit {

  apiUrl: string;

  constructor(private messageService: NzMessageService) {
    this.apiUrl = environment.apiUrl;
  }
  ngOnInit() {

  }



}
